import React from "react";
import { Scope } from "informed";
import { TextInput, SelectInput, GradientInput, ColorPicker, IconPicker } from "../../../shared/Forms";
import PropTypes from "prop-types";

const ExperienceInputs = props => {
	const { index, experiences } = props;
	let data = [];
	if (experiences && experiences.length > 0) {
		data = experiences.map(experience => ({
			key: experience.id,
			value: experience.id,
			label: experience.name,
		}));
	}

	return (
		<Scope scope={`experiences[${index}]`}>
			{experiences && experiences.length > 0 && (
				<SelectInput field="experienceId" id="experienceId" values={data} placeholder="Experience" isRequired />
			)}
			<TextInput field="title" id="title" placeholder="Title" isRequired />
			<TextInput field="subtitle" id="subtitle" placeholder="Subtitle" />
			<GradientInput field="backgroundGradient" id="backgroundGradient" placeholder="Background Gradient" />
			<ColorPicker field="backgroundColor" id="backgroundColor" placeholder="Background Color" />
			<IconPicker field="icon" id="icon" placeholder="Icon" />
		</Scope>
	);
};

ExperienceInputs.propTypes = {
	experiences: PropTypes.array,
	index: PropTypes.number,
};

export default ExperienceInputs;
